export default __webpack_public_path__ + "static/media/1_6_hl.ad51c860.png";